<header id="mainMenu" #header>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="menu desktop">
          <a routerLink="/" class="logo" (mouseenter)="checkHover()">
            <div class="contentImage">
              <img ngSrc="/generals/logo-sitsa-color.svg" alt="Logo Sitsa" fill />
            </div>
          </a>
          <nav>
            <ul class="navLinks">
              <li
                id="megaMenuEquipos"
                class="navLink"
                (mouseenter)="toggleMegaMenuEquipments()"
                (mouseleave)="checkHover()"
              >
                <button class="dropdown">Equipos</button>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/marcas">Marcas</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/refacciones">Refacciones</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/servicios">Servicios</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/sucursales">Sucursales</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/destacados">Destacados</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/blog">Blog</a>
              </li>
              <li
                class="navLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="checkHover()"
              >
                <a routerLink="/contacto">Contacto</a>
              </li>
            </ul>
          </nav>
          <div class="contactMenu" (mouseenter)="checkHover()">
            <a href="tel:8000074872" class="btnSitsa">800 007 48 72</a>
          </div>
        </div>
        <div class="menu mobile">
          <button class="navLinksMenu" aria-label="Menú">
            <div class="contentImage" (click)="toggleMenuMobile()" aria-hidden="true">
              <img ngSrc="/generals/icon-menu.svg" alt="icono menú" fill />
            </div>
            <div class="contentImage" (click)="toggleMenuMobile()" aria-hidden="true">
              <img ngSrc="/generals/icon-close.svg" alt="icono menú" fill />
            </div>
          </button>
          <a routerLink="/" class="logo">
            <div class="contentImage">
              <img ngSrc="/generals/logo-sitsa-color.svg" alt="logo Sitsa" fill />
            </div>
          </a>
          <div class="contactMenu">
            <a href="tel:8000074872" class="btnSitsa">
              <div class="contentImage">
                <img ngSrc="/generals/icon-phone-white.svg" alt="icono teléfono" fill />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-mega-menu-equipments (closeMenu)="toggleMegaMenuEquipments()" />
</header>

<nav id="menuMobile" aria-label="Menú principal">
  <div class="mobile-panels" [class.sub-open]="mobileSubPanel() !== null">
    <!-- Panel principal -->
    <div class="panel-main">
      <div class="links" #menuMobileLinks>
        <button class="dropdown" (click)="toggleDropdownMobile()">
          Equipos
          <div class="contentImage">
            <img ngSrc="/generals/icon-caret-down.svg" alt="icono arrow down" fill />
          </div>
        </button>
        <div class="pages">
          <button class="subPanelLink" (click)="openMobileSubPanel('new-equipment')">
            Equipo nuevo
            <div class="contentImage">
              <img ngSrc="/generals/icon-caret-down.svg" alt="icono" fill />
            </div>
          </button>
          <button class="subPanelLink" (click)="openMobileSubPanel('used-equipment')">
            Equipo usado
            <div class="contentImage">
              <img ngSrc="/generals/icon-caret-down.svg" alt="icono" fill />
            </div>
          </button>
          <a
            routerLink="/renta"
            routerLinkActive="active"
            (click)="toggleDropdownMobile(); toggleMenuMobile()"
            >Renta de equipos</a
          >
        </div>
        <a routerLink="/marcas" routerLinkActive="active" (click)="toggleMenuMobile()">Marcas</a>
        <a routerLink="/refacciones" routerLinkActive="active" (click)="toggleMenuMobile()">Refacciones</a>
        <a routerLink="/servicios" routerLinkActive="active" (click)="toggleMenuMobile()">Servicios</a>
        <a routerLink="/sucursales" routerLinkActive="active" (click)="toggleMenuMobile()">Sucursales</a>
        <a routerLink="/destacados" routerLinkActive="active" (click)="toggleMenuMobile()">Destacados</a>
        <a routerLink="/blog" routerLinkActive="active" (click)="toggleMenuMobile()">Blog</a>
        <a routerLink="/contacto" routerLinkActive="active" (click)="toggleMenuMobile()">Contacto</a>
      </div>
    </div>
    <!-- Panel categorías -->
    <div class="panel-sub">
      <div class="links">
        <button class="back" (click)="closeMobileSubPanel()">
          <div class="contentImage">
            <img ngSrc="/generals/icon-caret-down.svg" alt="volver" fill />
          </div>
          {{ mobileSubPanel() === 'used-equipment' ? 'Equipo usado' : 'Equipo nuevo' }}
        </button>
        @if (mobileSubPanel() === 'new-equipment') {
          @for (cat of newCategories(); track cat.id) {
            <a
              [routerLink]="['/equipos', cat.slug]"
              routerLinkActive="active"
              (click)="closeMobileSubPanel(); toggleMenuMobile()"
            >{{ cat.name }}</a>
          }
          <a
            routerLink="/equipos"
            class="seeAll"
            (click)="closeMobileSubPanel(); toggleMenuMobile()"
          >Ver equipos nuevos</a>
        }
        @if (mobileSubPanel() === 'used-equipment') {
          @for (cat of usedCategories(); track cat.id) {
            <a
              [routerLink]="['/usado/categorias', cat.slug]"
              routerLinkActive="active"
              (click)="closeMobileSubPanel(); toggleMenuMobile()"
            >{{ cat.name }}</a>
          }
          <a
            routerLink="/usado"
            class="seeAll"
            (click)="closeMobileSubPanel(); toggleMenuMobile()"
          >Ver equipos usados</a>
        }
      </div>
    </div>
  </div>
</nav>
